import React from 'react'
import { Banner } from '../styles.style'
import bannerMobile from './../../../../../../assets/images/compre-e-ganhe/compre-e-ganhe-mobile.png'
import bannerDesktop from './../../../../../../assets/images/compre-e-ganhe/compre-e-ganhe.png'
import { isMobile } from './././././../../../../../helpers'

const BannerComponent = () => {
	return (
		<Banner>
			<img
				src={isMobile() ? bannerMobile : bannerDesktop}
				alt="Compre e Ganhe"
				className="img-responsive"
			/>
		</Banner>
	)
}

export default BannerComponent
